import { useNavigate } from 'react-router-dom'
import { LiaHandPointer } from 'react-icons/lia'

import styles from './styles.module.scss'

export const ToBePartner = () => {
  const navigate = useNavigate()

  const redirectToPartner = () => navigate('/partner-schools')

  return (
    <section className={styles.container}>
      <div className={styles.cursor}>
        <LiaHandPointer size={24} color="#ffffff" />
      </div>
      <img
        onClick={redirectToPartner}
        src="/courses/to_be_partner.png"
        alt="Seja Parceiro"
        className={styles.image}
      />
    </section>
  )
}
